export default __webpack_public_path__ + "static/media/two-circle.14665b41.png";